export default __webpack_public_path__ + "static/media/COMBUSTIBLE.fded668e.svg";